import { Modal, Box, IconButton, Typography, Divider, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FlightCardItemDetailed from './FlightCardItemDetailed';
import { Offer, PassengerPricing } from '~/types';
import { useTheme } from '@mui/material/styles';

interface FlightCardItemDetailsModalProps {
  offer: Offer;
  passengerPricing: PassengerPricing[];
  open: boolean;
  onClose: () => void;
  isSearchPage?: boolean;
}

const FlightCardItemDetailsModalModal = ({ offer, passengerPricing, open, onClose, isSearchPage = false }: FlightCardItemDetailsModalProps) => {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));

  const itineraries = offer.itineraries;
  const outbound = itineraries.outbound;
  const inbound = itineraries.inbound ? itineraries.inbound : null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 5,
        maxHeight: "90%",
        overflowY: 'auto',
        minWidth: isMdDown ? '80%' : '65%',
        maxWidth: isMdDown ? '80%' : 'auto',
      }}>
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', top: 10, right: 10 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
          Trip Details
        </Typography>
        <FlightCardItemDetailed
          legGroup={outbound}
          passengerPricing={passengerPricing}
          isSearchPage={isSearchPage}
        />
        {
          inbound &&
          <>
            <Divider sx={{ mt: 5, mb: 5 }} />
            <FlightCardItemDetailed
              legGroup={inbound}
              passengerPricing={passengerPricing}
              isSearchPage={isSearchPage}
            />
          </>
        }
      </Box>
    </Modal>
  );
};

export default FlightCardItemDetailsModalModal;
